import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Table } from 'antd';
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-user',
  }
  componentDidMount() {
    const { sysStore: { init, getCheckList } } = this.props;
    init();
    getCheckList();
  }
  getColumns = () => {
    return [
      { title: '用户名', dataIndex: 'm_name', key: 'm_name', },
      { title: '公司', dataIndex: 'm_Comname', key: 'm_Comname', },
      { title: '分部', dataIndex: 'm_branch', key: 'm_branch', },
      { title: '部门', dataIndex: 'm_department', key: 'm_department', },
      { title: '岗位', dataIndex: 'm_position', key: 'm_position', },
      { title: '角色', dataIndex: 'm_role', key: 'm_role', },
      { title: '登录账号', dataIndex: 'm_user', key: 'm_user', },
      { title: '登录时间', dataIndex: 'createtime', key: 'createtime', }
    ];
  }
  onTableChange = (current, pageSize) => {
    const { sysStore: { getCheckList, setMobxState } } = this.props;
    setMobxState({ current, pageSize });
    getCheckList({ current, pageSize });
  }
  render() {
    const { prefixCls, sysStore: { checkList, checkCount, loading, pageSize, current } } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Table
          rowKey="m_id"
          loading={loading}
          bordered={true}
          dataSource={toJS(checkList)}
          columns={this.getColumns()}
          pagination={{
            total: checkCount,
            pageSize: pageSize,
            current: current,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => (<span>共{total}条</span>),
            onChange: this.onTableChange,
            onShowSizeChange: (page, size) => this.onTableChange(1, size),
          }} />
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/user/UserOnlineList.js